// extracted by mini-css-extract-plugin
module.exports = {"searchSection":"SuccessMessageRetry_searchSection__1gi8_","searchControle":"SuccessMessageRetry_searchControle__3aECB","subTitle":"SuccessMessageRetry_subTitle__3UUZr"};